import apiClient from '../utils/apiClient.js';

const getUserLanguage = () => {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        return user.preferred_language || 'en';
    } catch {
        return 'en';
    }
};

const requestBasicLlamaReply = async (message) => {
    const response = await apiClient.post('/api/chatbot/generate', {
        text: message,
        language: getUserLanguage()
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || 'Chat service unavailable');
    }

    const data = await response.json();
    if (!data?.content) {
        throw new Error('Invalid response from chat service');
    }

    return data.content;
};

/**
 * Handler → POST /api/chat/:chat_id/message
 * Functionality: Send user text; returns latest bot reply string.
 * Input: message, chatId, optional reference_analysis_id, detailed flag
 * Output: bot Text string
 * Collections: eddy_chat_sessions (server)
 * Example: await sendnsee('Hello', 'CHAT_abc') → "Hi, I'm Eddy..."
 */
export const sendnsee = async (message, chatId, reference_analysis_id = null, detailed = false) => {
    try {
        const response = await apiClient.post(`/api/chat/${chatId}/message`, {
            Text: message,
            reference_analysis_id: reference_analysis_id,
            detailed: detailed
        });

        const data = await response.json();

        if (response.ok && Array.isArray(data.Messages) && data.Messages.length > 0) {
            return data.Messages[data.Messages.length - 1].Text;
        }

        console.warn('Chat message endpoint failed, falling back to basic Llama API');
        return await requestBasicLlamaReply(message);
    } catch (error) {
        try {
            return await requestBasicLlamaReply(message);
        } catch (fallbackError) {
            console.error('Error in sendnsee:', error);
            throw fallbackError;
        }
    }
};

/**
 * Handler → GET /api/chat/:chat_id/analyses
 * Functionality: List trajectory analyses linkable in chat.
 * Output: array of { id, timestamp, content, preview }
 */
export const getAvailableAnalyses = async (chatId) => {
    try {
        // console.log('Fetching analyses for chat:', chatId);
        const response = await apiClient.get(`/api/chat/${chatId}/analyses`);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        // console.log('Received analyses:', data);
        return data;
    } catch (error) {
        console.error('Error fetching analyses:', error);
        throw error;
    }
};
